export default {
  fontFamily: "Calibri, Candara, Segoe, 'Segoe UI', Optima, Arial, sans-serif",
  fontSize: "11pt",
};
